import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../../UserInfo";
import {
  criarContribuinteDs,
  criarQualificacaoSociosDs,
} from "../../../DataSources";
import sysCodigoDescricao from "../../../components/sysCodigoDescricao";
import axiosApi from "../../../api-axios";
import ContribuinteBox from "../../contribuintes/ContribuinteBox";
import { ScrollView, Button } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ShowError from "../../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  cpbsId: undefined,
  inscricaoCpbs: undefined,
  contribuinteId: undefined,
  qualificacaoId: undefined,
  responsabilidade: 0,
  principal: false,
  fim: undefined,
  inicio: undefined,
};

export default class UsuariosNfseForm extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = { ...(_cadastroCorrente || template), popupVisivel: false };
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.contribuinteDs = criarContribuinteDs();

    //Funções do contribuinte
    /*
    /*
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa = this.onContribuinteSelecionadoPesquisa.bind(
      this
    );
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinteErro = this.setNomeContribuinteErro.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    /*
   /*
   */
    //Fim da funções do contribuinte

    this.qualificacaoOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      searchPlaceholder: "Procurar",
      cancelButtonText: "Cancelar",
      noDataText: "Nenhum registo encontrado",
      placeholder: "Escolha...",
      dataSource: criarQualificacaoSociosDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };
    this.responsabilidadeOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      noDataText: "Nenhum registo encontrado",
      placeholder: "Escolha...",
      dataSource: [
        { id: 0, descricao: "Nenhuma" },
        { id: 1, descricao: "Responsável" },
        { id: 2, descricao: "Co-Responsável" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {


    const cpbsId = this.props.match.params.inscricao;

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.inscricao === undefined) {
        notify("Cpbs inexistente", "error");
        this.props.history.push("/cpbs");
      }

      if (this.props.match.params.id === undefined) {
        this.setState({ ..._cadastroCorrente });
      }
      if (
        this.props.match.params.inscricao !== undefined &&
        this.props.match.params.id !== undefined
      ) {
        axiosApi.get(`/cpbs/prefeitura/${UserInfo.getPrefeitura()}/${cpbsId}/socios/`)
          .then((result) => {
            if (result.data.data.length > 0) {
              const socio = result.data.data.find(
                (registro) =>
                  registro.id.toString() === this.props.match.params.id
              );

              this.setState({
                id: socio.id,
                cpbsId: this.props.match.params.inscricao,
                contribuinteId: socio.contribuinte.sequencial,
                qualificacaoId: socio.qualificacaoId,
                responsabilidade: socio.responsabilidade,
                principal: socio.principal,
                inicio: socio.inicio,
                fim: socio.fim,
              });
              this.atualizarNomeContribuinte();
            }
          });
      }
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  //Funções do contribuinte
  /*
  /*
  */

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {

    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then(result => {
        if (result.length > 0) {
          this.setNomeContribuinte(result[0]);
        }
        else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    console.log(contribuinte);
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({ contribuinteId: e.row.data.sequencial, popupVisivel: false });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do contribuinte

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.props.location.dadosCpbs} colCount={3}>
            <GroupItem caption="DADOS CPBS" colSpan={3} colCount={5}>
              <SimpleItem
                dataField={"inscricao"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Inscrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"contribuinteNome"}
                colSpan={4}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Nome" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <Form formData={this.state} colCount={3}>
            <GroupItem caption="CPBS SÓCIOS" colSpan={3} colCount={3}>
              <SimpleItem colSpan={3} component={this.renderContribuinte}>
                <Label text="Contribuinte" />
              </SimpleItem>
              <SimpleItem
                dataField={"qualificacaoId"}
                editorType={"dxLookup"}
                editorOptions={this.qualificacaoOptions}
                colSpan={2}
              >
                <Label text="Qualificação" />
              </SimpleItem>
              <SimpleItem
                dataField={"responsabilidade"}
                editorType={"dxSelectBox"}
                editorOptions={this.responsabilidadeOptions}
                colSpan={1}
              >
                <Label text="Responsabilidade" />
              </SimpleItem>
              <SimpleItem
                dataField={"principal"}
                editorType={"dxCheckBox"}
                colSpan={1}
              >
                <Label text="Principal" />
              </SimpleItem>
              <SimpleItem
                dataField={"inicio"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Data Início" />
              </SimpleItem>
              <SimpleItem
                dataField={"fim"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Data Fim" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "15px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} />
            </div>
          </div>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={() => this.setState({ popupVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = {
      ...this.state,
      prefeituraId: UserInfo.getPrefeitura(),
      cpbsId: parseInt(this.props.match.params.inscricao),
    };
    axiosApi
      .post(`/cpbs/prefeitura/${UserInfo.getPrefeitura()}/add_socios`, entidade)
      .then((response) => {
        if (response.status === 200) {
          notify("Cadastro efetuado com sucesso", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        } else {
          notify(response.statusText, "error");
        }
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
